import React from 'react'
import { Modal, notification } from "antd";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from 'yup';
import axiosInstance from "../../../../../../Services/axiosCommon";
import { CancelButton, SubmitButton } from "../../../../../../Components/Utils/Buttons";
import { NuInput, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import DropDownAdd from "../../../../../../Components/Utils/selectAdd";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";

function CreateSubOthers({open,data,onCancel,getData,projectId,itId,Category,Division,Unit,itemsCategory}) {
    const [api, contextHolder] = notification.useNotification();
 
    const [isLoading,setIsLoading] = useState(false);
    const [createNew, setCreateNew] = useState({
        projectId: "",
        activity: "",
        category: "",
        division: "",
        amount: "",
        unit: "",
        quantity: "",
        comments: ""
             
    });
  // console.log(projectId,"probjnj");
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema:yup.object({
        activity:yup.string().required("Activity Name is Requried")
      }),
      onSubmit: (value,{resetForm}) => {    
        setIsLoading(true);
        const values = {
          ...value,
          projectId: Number(projectId),
          title_id: itId,
          
        }
        axiosInstance
        .post(`/others/`, values)
          .then((res) => {
            console.log(res);
            if (res.status === 201 || res.data.status == true) {
              setIsLoading(false);
              getData();
              resetForm();
              api.success({
                message: `Material Item Creation successfully`,
                description: res?.data?.msg || "Added In Tittle",
                placement: "bottomRight",
              });
              onCancel();
            } else {
              api.error({
                message: `Material Item  Creation failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
              setIsLoading(false);
            }
          })
          .catch((err) => {
            api.error({
              message: `Material Item Creation failed`,
              description: err?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
            setIsLoading(false);
          });
      },
    });
  // const { category: itemsCategory, subCategory: itemsSubCategory, getCategory, fetchSubCategory } = UseCatSubCatDropDown('/category/ItemCategory', "ItemCategory", formik?.values?.category);
    
    useEffect(() => {
      const amount = formik?.values?.actual_quantity * formik?.values?.actual_Price
      formik.setFieldValue("amount", amount);
    }, [formik?.values?.actual_quantity,formik?.values?.actual_Price]);
  
    return (
      <>
      {contextHolder}
      <Modal
        open={open}
        title={"Create Others"}
        width={"50%"}
        className="my-modal"
        centered
        footer={[]}
        onCancel={onCancel}
      >
      <form onSubmit={formik.handleSubmit} >
        <div className=" w-full flex flex-wrap">
        <NuInput
                           type="text"

                 label="Activity"
                 formik={formik}
                 placeholder="Activity"
                 name="activity"
                 width="w-full md:w-1/2"
                 isRequired={true}
                /> 

                <FormikSelectTwo
                  label="Category"
                  Options={itemsCategory||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="category"
                  width="w-full md:w-1/2"
                  // getFunc={refOthersCategory}
                  displayProperty={"Category"}
                  propertyName={"OthersCategory"}
                  isRequired={true}
                /> 

                <FormikSelectTwo
                  label="Division"
                  Options={Division||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="division"
                  width="w-full md:w-1/2"
                  // getFunc={refOtherDivision}
                  displayProperty={"Division"}
                  propertyName={"OtherDivision"}
                  isRequired={true}
                /> 

             

                <FormikSelectTwo
                  label="Unit"
                  Options={Unit||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="unit"
                  width="w-full md:w-1/2"
                  // getFunc={refOtherUnit}
                  displayProperty={"Unit"}
                  propertyName={"OtherUnit"}
                  isRequired={true}
                />
 
                <NuInput
                             type="number"

                 label="Quantity"
                 formik={formik}
                 placeholder="Quantity"
                 name="quantity"
                 width="w-full md:w-1/2"
                 isRequired={true}
                />    
                   <NuInput
                             type="number"

                 label="Amount"
                 formik={formik}
                 placeholder="Amount"
                 name="amount"
                 width="w-full md:w-1/2"
                 isRequired={true}
                />  

                  <NuTextArea
                  label="Comments"
                  placeholder="Comments"
                  formik={formik}
                  name="comments"
                  
                  new_width="w-full"
                />

              <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
                <CancelButton handleClick={onCancel} />
                <SubmitButton isLoading={isLoading} />
              </div>
        </div>
        </form>
      </Modal>
      </>
    )
}

export default CreateSubOthers